export default __webpack_public_path__ + "static/media/shoes6.993a39b0.jpg";